<template>
  <div class="jps-curation">
    <CurationRenderer
      class="jps-organization"
      v-if="orgPage"
      :curation="orgPage"
      :show-edit="showEdit"
      @edit="edit()"
    />
  </div>
</template>

<script lang="ts" setup>
definePageMeta({
  qsearch: true,
  disableDefaultMargin: true,
})

const { getPageAndCache } = usePage()
const { meta } = await getPageAndCache()
useHead(meta)

const { langPath } = useI18n()
const route = useRoute()
const router = useRouter()
const dataStore = useDataStore()
const userStore = useUserStore()

const orgPage = computed(() => {
  return dataStore.curation(route.params.orgId + '-org')
})

const showEdit = computed(() => {
  return orgPage.value && userStore.hasEditForData(orgPage.value)
})

const edit = () => {
  router.push(langPath(`/management/organization/${route.params.orgId}/page`))
}
</script>

<style lang="scss" scoped>
.jps-curation {
  .cur-component:not(:first-child) {
    margin-top: 1em;
  }
}
</style>
